<script>
import Vue from "vue";
import Service from "../../../service/Service";
import addDialog from "./addDialog";
import deleteDialog from "../../../dialogs/DeleteDialog.vue";
import { getLessonTime, getPupilFullName, getTeacherFullName} from "@/utils/parseObj";
import MultiSelectLessonTime from "@/components/selects/MultiSelectLessonTime.vue";
import {mapState} from "vuex";

export default {
    name: "PresenceConstant",
    components: { addDialog, deleteDialog, MultiSelectLessonTime},
    data() {
        return {
            ENTITY: 'constant-presence',
            loading: true,
            service: null,
            isDialogAdd: false,
            isDialogDelete: false,
            selectedRows:[],
            data: [],
            adminSystemDate: [],
            columns: [

            ],

        }
    },

    computed: {
        featureOn() {
            const a= process.env.VUE_APP_0_CONSTANT_PRESENCE
            return a === "true"
        },
        ...mapState([ "user"]),
    },
    mounted() {
        this.columns = [
            {field: "pupil", header: "תלמיד", type: "pupil", editable: false},
            {field: "daysInWeek", header: "ימים בשבוע", type: "daysInWeek", editable: this.isAdmin()},
            {field: "lessonTimes", header: "שיעורים", type: "lessonTimes", editable:this.isAdmin()},
            {field: "description", header: "תיאור", type: "string", editable: this.isAdmin()},
            {field: "reason", header: "סיבה", type: "string", editable: this.isAdmin()},
            {field: "startDate", width:'50%', header: "תאריך התחלה", type: "date", editable: this.isAdmin()},
            {field: "endDate", width:'50%', header: "תאריך סיום", type: "date", editable: this.isAdmin()},
            {field: "color",width:'30%', header: "צבע", type: "color", editable: this.isAdmin()},
            {field: "active", width:'30%', header: "פעיל", type: "checkbox", editable:this.isAdmin()},
            ]
    },
    async created() {
        this.service = new Service()
        const data = await this.service.get(this.ENTITY)
        this.loading = false
        this.data = data

        // this.initAdminSystemDate()
    },
    methods: {
        isAdmin(){
            const user = this.user
            return user?.role === 'ADMIN'
        },

        async onCellEditComplete(event) {
            try {
                let objToSend = {}
                if (this.itemAfterEditing?.id === undefined) {
                    objToSend = event.data

                } else {
                    const index = this.data.findIndex(
                        (item) => item.id === this.itemAfterEditing.id
                    );
                    this.data[index] = this.itemAfterEditing;
                    Vue.set(this.data, index, this.itemAfterEditing);
                    objToSend = JSON.parse(JSON.stringify(this.itemAfterEditing));
                    console.log(this.itemAfterEditing)
                }

                if (!objToSend.id) throw "error"
                await this.service.update(objToSend, this.ENTITY)
                this.openNotification(
                    "success",
                    `מעולה`,
                    `רשומה התעדכנה`
                )
            } catch (e) {
                console.log(e)
                this.openNotification(
                    "danger",
                    `אופס`,
                    `${e} : רשומה לא התעדכנה`
                );
            }
        },
        onCellEdit(newValue, props) {
            this.itemBeforeEditing = {...props.data};
            this.itemAfterEditing = {...props.data};
            this.itemAfterEditing[props.column.field] = newValue;
        },
        getTeacherName(id) {
            return getTeacherFullName(id)
        },
        getLessonTimes(ids) {
            // ids?.sort((a, b) => {
            //     if (a < b) {
            //         return -1;
            //     } else if (a > b) {
            //         return 1;
            //     }
            //     return 0;
            // })
            const lessons = ids?.map(id => getLessonTime(id))
            return lessons?.join(", ")
        },
        getPupilName(pupil) {
            return getPupilFullName(pupil)
        },
        rowClass(data) {
            return data.forAdminOnly === true || data.forOldShow === true ? "row-gray" : null;
        },
        addItem(daterange){
            this.data = [...this.data, daterange]
        },
        async deleteItem() {

            const service = new Service()
            try {
                const selscteds = this.selectedRows.map(a => a.id)
                await service.deleteMany(selscteds, this.ENTITY)
                this.isDialogDelete = false;

                selscteds.forEach((selected) => {
                    this.data = this.data.filter((item) => item.id !== selected);

                });
                this.selectedRows = []
                this.openNotification("success", `מעולה`, `מחקנו ${this.selectedRows.length}  רשומות מהמערכת`);
            } catch (e) {
                this.openNotification("danger", `אופס`, `לא הצלחנו למחוק`);
                this.isDialogDelete = false;

                this.selectedRows = []

            }

        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
        },
    },
}
</script>

<template>
<div>
    <DataTable
            v-if="featureOn"
            :rowClass="rowClass"
            :value="data"
            :selection.sync="selectedRows"
            @cell-edit-complete="onCellEditComplete"
            columnResizeMode="fit"
            dataKey="id"
            stateStorage="local"
            stateKey="presence-constant-state"
            editMode="cell"
            :loading="loading"
            sortField="createdAt"
            :sortOrder="-1"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 20, 50]"
            currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
    >
        <!-- header -->

        <template #header>
            <div class="p-p-2 table-header">
                <div class="p-m-1 p-d-inline-flex">
                    <h1 style="text-align: center">נוכחות קבועה</h1>
                </div>

                <div class="p-d-flex">

                    <Button
                            v-tooltip.top="'מחיקה'"
                            v-if="selectedRows.length > 0 && user?.role === 'ADMIN'"
                            icon="pi pi-trash"
                            class="p-mr-2 p-button-danger"
                            @click="isDialogDelete = true"
                    />
                    <Button
                            v-if="user?.role === 'ADMIN'"
                            v-tooltip.top="'הוספה'"
                            icon="pi pi-plus"
                            class="p-mr-2 p-button-success"
                            @click="isDialogAdd = true"
                    />
                </div>
            </div>
        </template>
        <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>
        <Column selectionMode="multiple" headerStyle="width: 3em"></Column>

        <!-- v-for -->
        <Column
                sortable
                :sortField="col.field || col.sort"
                :headerStyle="`width: ${col.width || `100%` }; text-align: rtl`"
                bodyStyle="text-align: right"
                v-for="col of columns"
                :field="col.field"
                :header="col.header"
        >
            <template #body="slotProps">
                <div v-if="col.type === 'string'">
                    {{ slotProps.data[col.field] }}
                </div>
                <div v-if="col.type === 'color'">
                    <ColorPicker :value="slotProps.data[col.field]"  />
                </div>
                <div v-if="col.type === 'daysInWeek'">
                     {{slotProps.data.daysInWeek }}
                </div>
                <div v-if="col.type === 'number'">
                    {{ slotProps.data[col.field] }}
                </div>
                <div v-if="col.type === 'subject'">
                    {{ getLessonName(slotProps.data[col.field]) }}
                </div>
                <div v-if="col.type === 'lessonTimes'">
<!--                    {{ // slotProps.data[col.field] }}-->
                    {{ getLessonTimes(slotProps.data[col.field]) }}
                </div>
                <div v-if="col.type === 'grade'">
                    {{ getGradeName(slotProps.data[col.field]) }}
                </div>
                <div v-if="col.type === 'date'">
                    {{ new Date(slotProps.data[col.field]).toLocaleDateString() }}
                </div>
                <div v-if="col.type === 'user'">
                    {{ getTeacherName(slotProps.data[col.field]) }}
                </div>
                <div v-if="col.type === 'pupil'">
                    {{ getPupilName(slotProps.data[col.field]) }}
                </div>
                <div v-if="col.type === 'checkbox'">
                    <checkbox
                            @input="onCellEdit($event, slotProps)"

                            v-model="slotProps.data[col.field]"
                            :binary="true"/>
                </div>
            </template>

            <template v-if="col.editable " #editor="slotProps">
                <div v-if="col.type === 'string'">
                    <InputText
                            :value="slotProps.data[slotProps.column.field]"
                            @input="onCellEdit($event, slotProps)"

                    />
                </div>
                <div v-if="col.type === 'daysInWeek'">
                    <MultiSelect  v-if="slotProps.data.daysInWeek" v-model="slotProps.data.daysInWeek"  :options="[1,2,3,4,5,6,7]" placeholder="ימים בשבוע"
                            :value="slotProps.data[slotProps.column.field]"
                            @input="onCellEdit($event, slotProps)"

                    />
                </div>
                <div v-if="col.type === 'lessonTimes'">
                    <multi-select-lesson-time useStore storage-name="presence-const-add" :defaultValue="slotProps.data[slotProps.column.field]" return-id @onSelect="onCellEdit($event, slotProps)"/>

                </div>
                <div v-if="col.type === 'color'">
                    <ColorPicker
                            :value="slotProps.data[slotProps.column.field]"
                            @input="onCellEdit($event, slotProps)"

                    />
                </div>
                <div v-if="col.type === 'number'">
                    <InputNumber
                            :value="slotProps.data[slotProps.column.field]"
                            @input="onCellEdit($event, slotProps)"

                    />
                </div>
                <div v-if="col.type === 'subject'">
                    <select-lesson  v-on:onSelect="onCellEdit($event.id, slotProps)" :defaultValue="slotProps.data[slotProps.column.field].id"/>
                </div>
                <div v-if="col.type === 'checkbox'">
                    <checkbox
                            @input="onCellEdit($event, slotProps)"

                            v-model="slotProps.data[slotProps.column.field]" :binary="true"></checkbox>

                </div>
                <div v-if="col.type === 'date'">
                    <Calendar
                            @input="onCellEdit($event, slotProps)"
                            shouldReturnLong
                            :touchUI="true"
                            :showButtonBar="true" :showTime="true" :value="new Date(slotProps.data[slotProps.column.field])" />
                </div>
            </template>
        </Column>
        <!-- v-for -->

        <template #footer>
            סה״כ {{ data ? data.length : 0 }} רשומות.
        </template>
    </DataTable>
    <h1 v-else class="p-p-6 ">
        יכולת זו לא פעילה
    </h1>
    <add-dialog
            v-if="isDialogAdd"
            :show="isDialogAdd"
            v-on:addItem="addItem"
            v-on:closeDialog="isDialogAdd = false"
    />
    <delete-dialog
            :title="'מחיקה'"
            :context="`האם תרצה להסיר  ${selectedRows?.length}רשומות מהמערכת?`"
            :show="isDialogDelete"
            v-on:choice="deleteItem"
    />
</div>
</template>


<style scoped>
>>>.row-gray{
    background-color: #e7e7e7 !important;;
}
</style>
